'use client'

import { Cell } from '@vinted/web-ui'

import { useSession } from '@marketplace-web/shared/session'
import { useTranslate } from '@marketplace-web/shared/i18n'

const TRANSLATE_PREFIX = 'policies_settings.legal_imprint'

const LegalImprint = () => {
  const { user } = useSession()
  const businessAccount = user?.business_account
  const translate = useTranslate(TRANSLATE_PREFIX)

  if (!businessAccount) return null

  const { legal_name: legalName, legal_code: legalCode } = businessAccount

  return (
    <>
      <Cell title={translate('title')} />
      <Cell title={translate('business_name')}>{legalName}</Cell>
      <Cell title={translate('legal_code')}>{legalCode}</Cell>
    </>
  )
}

export default LegalImprint
